import React, { PureComponent } from 'react';
import {
  Card, CardBody, Col, Button, ButtonToolbar,
} from 'reactstrap';  
import { reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { hasAccess } from "../../Services/SecurityService";
import { addGrupo, updateGrupo } from "../../Services/GrupoService";
import { FullWideNotification } from '../../../shared/components/Notification';
import NotificationSystem from 'rc-notification';

let notificationTC = null;

class CrudEdit extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      geologias: [],
      checkboxGeologias: [],
      checkboxGeologiasSelected: [],
      data: {
        id: '',
        name: '',
        description: '',
        bibliografia: '',
        status: '',
        deleted: '',
        createdAt: '',
        updatedAt: ''
      }
    };
  }

  handleSubmit(e){
    const data = { ...this.state.data }

    if(this.validateEntries()){

      if(data.status === undefined || data.status === null || data.status === ''){
        data['status'] = 'ATIVO';
      }
      
      let request = {
        grupo: data,
        geologiaGrupoList: this.getGeologiaGrupo()
      };
  
      if(data.id === undefined || data.id === null || data.id === ''){
        addGrupo(request)
        .then(obj => {
          if(obj !== null && obj !== undefined && obj.error === undefined){
            if(obj.erros.length === 0){
              this.props.updateTable({}, this.props.t('forms.dataCreateSuccess'));
              this.clear();              
            }else{
              if(obj.erros !== undefined && obj.erros !== undefined && obj.erros.length > 0){
                for(let i = 0; i < obj.erros.length; i++){
                  this.show('danger', this.props.t('erros.'+obj.erros[i]));
                }
              }
            }
          } else {
            this.show('danger', this.props.t('forms.dataCreateError'));
          }
        });
      }else{
        updateGrupo(request)
        .then(obj => {
          if(obj !== null && obj !== undefined && obj.error === undefined){
            if(obj.erros.length === 0){
              this.props.updateTable(obj, this.props.t('forms.dataUpdateSuccess'));
            }else{
              if(obj.erros !== undefined && obj.erros !== undefined && obj.erros.length > 0){
                for(let i = 0; i < obj.erros.length; i++){
                  this.show('danger', this.props.t('erros.'+obj.erros[i]));
                }
              }  
            }
          } else {
            this.show('danger', this.props.t('forms.dataUpdateError'));
          }
        });
      }
    }
  }

  validateEntries(){
    const data = { ...this.state.data }
    let validated = true;

    if(data.name === undefined || data.name === null || data.name === ''){
      this.show('danger', this.props.t('forms.requiredFieldName'));
      validated = false;
    }

    if(data.description === undefined || data.description === null || data.description === ''){
      this.show('danger', this.props.t('forms.requiredFieldDescription'));
      validated = false;
    }

    if(data.bibliografia === undefined || data.bibliografia === null || data.bibliografia === ''){
      this.show('danger', this.props.t('forms.requiredFieldBibliografia'));
      validated = false;
    }

    return validated;  
  }

  getGeologiaGrupo() {
    let geologiaGrupo = [];
    if(this.state.checkboxGeologiasSelected.length > 0){
      for(let j = 0; j < this.state.checkboxGeologiasSelected.length; j++){
        for(let i = 0; i < this.state.geologias.length; i++){
          if(this.state.checkboxGeologiasSelected[j].value === this.state.geologias[i].id){
            geologiaGrupo.push( {geologia: this.state.geologias[i]} );
            break;
          }
        }
      }
    }
    return geologiaGrupo;
  }

  loadData(selected, geologias, geologiaGrupo) {
    let options = [];
    let optionsSelected = [];
    let obj = {};
    if(geologias !== undefined && geologias !== null && geologias.length > 0 && this.state.geologias.length === 0){
      options = [];
      optionsSelected = [];
      if(geologiaGrupo !== undefined && geologiaGrupo !== null && geologiaGrupo.length > 0){
        for(let i = 0; i < geologias.length; i++){
          obj = {value:geologias[i].id, label: geologias[i].simb1000, checked: true};
          for(let j = 0; j < geologiaGrupo.length; j++){
            if(geologias[i].id === geologiaGrupo[j].geologia.id){
              obj.checked = true;
              optionsSelected.push(obj);
              break;
            }
          }
          options.push(obj);
        }
      }else{
        for(let i = 0; i < geologias.length; i++){
          options.push({value:geologias[i].id, label: geologias[i].simb1000, checked: false});
        }
      }

      this.setState({ 
        checkboxGeologias: options, 
        checkboxGeologiasSelected: optionsSelected,
        geologias: geologias 
      });
    }
    
    if(selected !== undefined && selected !== null){
      if(selected.id === 0){
        this.clear();
      }else {
        this.setState({ 
          data: selected
        }, () => {});
      }
    }
  }

  componentDidMount() {
    const { selected, geologias, geologiaGrupo  } = this.props;
    this.loadData(selected, geologias, geologiaGrupo);
    NotificationSystem.newInstance({ style: { top: 65 } }, n => notificationTC = n);
  }

  componentDidUpdate(props, state) {
    if(props.selected !== this.props.selected || props.geologias !== this.props.geologias || 
        props.geologiaGrupo !== this.props.geologiaGrupo){
      this.loadData(this.props.selected, this.props.geologias, this.props.geologiaGrupo);
    }
  }

  componentWillUnmount() {
    notificationTC.destroy();
  }



  updateField(event) {
    const data = { ...this.state.data }
    data[event.target.name] = event.target.value
    this.setState({ data });
  }

  updateCheckboxGeologia(event) {
    let selecteds = [];
    event.checked = !event.checked;
    if(this.state.checkboxGeologiasSelected.length > 0){
      for(let i = 0; i < this.state.checkboxGeologiasSelected.length; i++){
        if(this.state.checkboxGeologiasSelected[i].value !== event.value){
          selecteds.push(this.state.checkboxGeologiasSelected[i]);
        }
      }
    }
    if(event.checked){
      selecteds.push(event);
    }
    this.setState({ checkboxGeologiasSelected: selecteds });
  }

  clear(){
    const data = { ...this.state.data }
    data['id'] = '';
    data['name'] = '';
    data['description'] = '';
    data['bibliografia'] = '';
    data['status'] = '';
    data['deleted'] = '';
    data['createdAt'] = '';
    data['updatedAt'] = '';
    this.setState({ 
      data,
      checkboxGeologiasSelected: []
    }, () => {});
  }

  cancel(event) {
    this.clear();
    this.props.updateTable({});
  }

  show = (color, message) => {
    return notificationTC.notice({
      content: <FullWideNotification
        color={color}
        message={message}
        />,
      duration: 3,
      closable: true,
      style: { top: 0, left: 0 },
      className: `full ltr-support`,
    });
  };

  render() {
    const { t } = this.props;
    
    let notOK = !hasAccess("MENU_GEOLOGICAL_GROUP_SAVE");

    let isEdit = false;
    if(this.state.data.id !== '' && this.state.data.id > 0){
      isEdit = true;
    }

    let checkboxesGeologias = [];

    let total = this.state.checkboxGeologias.length;
    if(total > 0){
      for(let i = 0; i < total; i++){
        checkboxesGeologias.push(
          <div key={"divgeologias_"+this.state.checkboxGeologias[i].value} className='form__form-inline' style={{width: '205px'}}>
            <input type="checkbox" 
              id={"checkboxgeologias_"+this.state.checkboxGeologias[i].value} 
              name={"checkboxgeologias_"+this.state.checkboxGeologias[i].value} 
              style={{float: 'left', width: '30px', height: '18px'}}
              onChange={e => this.updateCheckboxGeologia(this.state.checkboxGeologias[i])}
              checked={this.state.checkboxGeologiasSelected.includes(this.state.checkboxGeologias[i])} 
            />
              <label 
                key={"labelgeologias_"+this.state.checkboxGeologias[i].value}
                htmlFor={"checkboxgeologias_"+this.state.checkboxGeologias[i].value} 
                style={{margin: 0, height: '25px'}}>
                {this.state.checkboxGeologias[i].label}
              </label>
          </div>
        );
      }
    }

    return (
      <Col md={12} lg={12}>
        <Card>
          <CardBody>
            <div className="form__form-group">
              <h3 className="page-subhead subhead">{t('forms.createUpdate')}</h3>
            </div>
            <div className="form">
              <div className="form__half">
                <div className="form__form-group">
                  <span title={t('forms.requiredField')} className="form__form-group-label">
                    {t('forms.name')} <span style={{color: "#ff0000"}}>*</span>
                  </span>
                  <div className="form__form-group-field">
                    <input type="hidden" 
                      name="id"
                      value={this.state.data.id} />
                    <input type="text" 
                      name="name"
                      value={this.state.data.name}
                      onChange={e => this.updateField(e)}
                      required
                    />
                  </div>
                </div>
              </div>
              <div className="form__form-group">
                <span title={t('forms.requiredField')} className="form__form-group-label">
                  {t('forms.geologia_form.title')} 
                </span>
                <div className="form__form-group-field" 
                  style={{border: '1px solid #CCCCCC', height: '400px', overflowY: 'auto', 
                          display: 'flow-root', flexWrap: 'wrap', paddingTop: '5px'}}>
                  
                  {checkboxesGeologias}

                </div>
              </div>
              <div className="form__form-group">
                <span title={t('forms.requiredField')} className="form__form-group-label">
                  {t('forms.description')} 
                </span>
                <div className="form__form-group-field">
                  <textarea 
                    name="description"
                    value={this.state.data.description || ""}
                    style={{width: "100%", height: "60px"}}
                    onChange={e => this.updateField(e)}
                  />
                </div>
              </div>
              <div className="form__form-group">
                <span title={t('forms.requiredField')} className="form__form-group-label">
                  {t('forms.bibliografia')} 
                </span>
                <div className="form__form-group-field">
                  <textarea 
                    name="bibliografia"
                    value={this.state.data.bibliografia || ""}
                    style={{width: "100%", height: "60px"}}
                    onChange={e => this.updateField(e)}
                  />
                </div>
              </div>

              <div className="form__form-group">
                <span className="form__form-group-label">
                  {t('forms.status')}
                </span>
                <div className="form__form-group-field">
                  <label className="radio-btn">
                    <input className="radio-btn__radio"
                      name="status"
                      type="radio"
                      value={t('forms.ativo')}
                      onChange={e => this.updateField(e)}
                      checked={this.state.data.status === 'ATIVO' ? true : false}
                    />
                    <span className="radio-btn__radio-custom"></span>
                    <span className="radio-btn__label">{t('forms.ativo')}</span>
                  </label>
                  <label className="radio-btn">
                    <input className="radio-btn__radio"
                      name="status"
                      type="radio"
                      value={t('forms.inativo')}
                      onChange={e => this.updateField(e)}
                      checked={this.state.data.status === 'INATIVO' ? true : false}
                    />
                    <span className="radio-btn__radio-custom"></span>
                    <span className="radio-btn__label">{t('forms.inativo')}</span>
                  </label>
                </div>
              </div>
              <ButtonToolbar className="form__button-toolbar">
                <Button color="primary" type="submit" disabled={notOK}
                  onClick={e => this.handleSubmit(e)}>
                  {t('forms.save')}
                </Button>
                <Button type="button" onClick={e => this.cancel(e)}>
                  {isEdit ? t('forms.voltar') : t('forms.cancel')}
                </Button>
              </ButtonToolbar>
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

export default reduxForm({
  form: 'grupoEdit', 
})(withTranslation('common')(CrudEdit));
